module.exports = __webpack_public_path__ + "img/wukuang.f8aac029.png";